import React from 'react';
import I18n from 'i18n-js';
import CoreLink from '@reverbdotcom/commons/src/components/core_link';

import {
  shippingGuideDetailsForCategoryUuids,
} from './item2_shipping_prompt_helpers';

interface Props {
  categoryUuids: string[];
}

export function ShipmentPackingHelpLink({
  categoryUuids,
}: Props) {
  const shippingPromptDetails = shippingGuideDetailsForCategoryUuids(categoryUuids || []);
  if (!shippingPromptDetails) { return null; }

  const guideLink = shippingPromptDetails.guideLink;
  const itemKey = shippingPromptDetails.i18ItemKey;

  return (
    <CoreLink
      target="_blank"
      className="ph ph-r ph-chevron-right size-110"
      to={guideLink}
    >
      {I18n.t(`discovery.shipmentPackingHelpLink.packingGuides.${itemKey}`)}
    </CoreLink>
  );
}

export default ShipmentPackingHelpLink;
